import { h } from "vue";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases as mdiAliases, mdi } from "vuetify/iconsets/mdi";

import iconValues, { customAliases } from "./icons";

import "@mdi/font/css/materialdesignicons.min.css";

const customIconSet = {
  component: (props) => {
    const iconName = props.icon;
    if (typeof iconName === "string" && iconName.startsWith("mdi-")) {
      return h(mdi.component, { ...props, icon: iconName });
    }
    const icon = iconValues[iconName]?.component;
    if (!icon) return null;
    return h(icon, { class: props.class, style: props.style });
  },
};

export default createVuetify({
  defaults: {
    global: {
      rounded: true,
    },
    VAutocomplete: {
      menuIcon: "chevronDown",
    },
    VSlider: { elevation: 0 },
    VRangeSlider: { elevation: 0 },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#4E4087",
          secondary: "#DDDCFF",
          "on-secondary": "#4E4087", // цвет элементов на фоне secondary(к примеру текста на кнопку с цветом secondary)
          accent: "#232451",
          error: "#FF6262",
          text: "#675D8B",
          border: "#CFCDF6",
          "bg-light": "#EFEFFF",
          "border-light": "#E0E0E0",
          "text-secondary": "#8786A8",
          "text-dark": "#666666",
          "bg-gray": "#F0F0F0",
          "text-main": "#212121",
        },
        variables: {
          "high-emphasis-opacity": 1,
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#12111A",
          surface: "#1B1A26",
          primary: "#9C8DDE",
          secondary: "#2A2740",
          "on-secondary": "#E8E6FC",
          accent: "#5C58A6",
          error: "#FF7575",
          text: "#E0DDF2",
          border: "#3D3959",
          "bg-light": "#211F30",
          "border-light": "#2A273D",
          "text-secondary": "#9A97B3",
          "text-dark": "#C5C2D9",
          "bg-gray": "#171520",
          "text-main": "#F5F5F5",
        },
        variables: {
          "high-emphasis-opacity": 1,
        },
      },
    },
  },
  icons: {
    defaultSet: "custom",
    aliases: { ...mdiAliases, ...customAliases },
    sets: {
      mdi,
      custom: customIconSet,
    },
  },
});
